import { loadStripe, Stripe } from "@stripe/stripe-js";

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Shared, lazily-created Stripe instance. Call it only from components that
 * actually render a payment form: `loadStripe` initialises Stripe with the
 * live key, which throws "Live Stripe.js integrations must use HTTPS" on any
 * non-https page. Creating it at module load (as before) ran on every
 * logged-in page via PageWrapper → AnualPlansModal.
 */
export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};
